<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.team.title }}</h2>
      <p>
        {{ wp.team.text }}
      </p>

      <RouterLink :to="{ name: 'about-team' }" class="button layout-section__cta">
        Explorez notre équipe
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutTeam',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.team.image})`
    }
  }
}
</script>
